import { createSlice } from '@reduxjs/toolkit'
import { logOut } from '../authentication/authenticationSlice';
import { getFactoryITVBond } from './thunks';

const initialState = { 
      info: null,
      loading: "idle",
      error: null
}

const factoryITVBondSlice = createSlice({
  name: 'factoryITVBond',
  initialState,
  reducers: {
    clearITVBondError: (state)=>{
      state.error = null
      state.loading = "idle"
    },
    clearITVBondInfo: (state) => {
      state.info = null;
    }
  },
  extraReducers: {
    [getFactoryITVBond.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryITVBond.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.info = action.payload
      
    },
    [getFactoryITVBond.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearITVBondError, clearITVBondInfo} = factoryITVBondSlice.actions;
export default factoryITVBondSlice.reducer